<template>
    <el-row class="container">
        <!--头部-->
        <el-col :span="24" class="topbar-wrap">
            <div class="topbar-title">
                <span style="font-size: 18px;color: #fff;">神州联保师傅小店系统管理后台</span>
                <!--展开折叠开关-->
                <div class="menu-toggle" @click="collapse">
                    <i class="icon iconfont icon-menufold" v-show="!isCollapse"></i>
                    <i class="icon iconfont icon-menuunfold" v-show="isCollapse"></i>
                </div>
            </div>
            <div class="topbar-account topbar-btn">
                <el-dropdown trigger="click">
                    <span class="el-dropdown-link userinfo-inner">
                        {{nickname}} <i class="icon iconfont icon-user"></i>
                        <i class="icon iconfont icon-down"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </el-col>

        <!--中间-->
        <el-col :span="24" class="main">
            <!--左侧导航-->
            <aside :class="{showSidebar:!isCollapse}">
                <!-- <el-radio-group v-model="isCollapse">
                    <el-radio-button :label="false">展开</el-radio-button>
                    <el-radio-button :label="true">收起</el-radio-button>
                </el-radio-group> -->
                <!--导航菜单-->
                <el-menu ref="menu" class="el-menu-vertical-demo" text-color="#fff" :default-active="activeIndex" unique-opened router :collapse="isCollapse" @select="handleSelect">
                    <el-menu-item index="/home">
                        <i class="icon iconfont el-icon-home"></i>
                        <span slot="title">首页</span>
                    </el-menu-item>
                    <template v-for="item in menusList">
                        <el-submenu :key="item.id" :index="item.menu_url" v-if="item.children">
                            <template slot="title">
                                <i class="icon iconfont" :class="item.icon"></i>
                                <span>{{item.menu_name}}</span>
                            </template>
                            <el-menu-item v-for="child in item.children" :index="child.menu_url" :key="child.id">{{child.menu_name}}</el-menu-item>
                        </el-submenu>
                        <!-- 一级菜单 -->
                        <el-menu-item :key="item.id" :index="item.menu_url" v-else>
                            <i class="icon iconfont" :class="item.icon"></i>
                            <span slot="title">{{item.menu_name}}</span>
                        </el-menu-item>
                    </template>
                </el-menu>
            </aside>

            <!--右侧内容区-->
            <section class="content-container">
                <div class="grid-content bg-purple-light">
                    <el-col :span="24" class="content-wrapper">
                        <!-- 过渡效果缓存方式 -->
                        <transition :name="name" :mode="mode">
                            <keep-alive> 
                                <router-view v-if="$route.meta.keepAlive"></router-view>
                            </keep-alive>
                        </transition>
                        <transition :name="name" :mode="mode">
                            <el-alert title="神州联保师傅小店系统管理后台" type="success" center show-icon v-if="activeIndex == '/home'"></el-alert>
                            <router-view v-if="!$route.meta.keepAlive"></router-view>
                        </transition>
                    </el-col>
                </div>
            </section>
        </el-col>

    </el-row>
</template>


<script>
import { bus } from '@/bus.js'
import storage from '@/common/storage.js'
export default {
    name: 'Home',
    data() {
        return {
            nickname: storage.getName(),
            isCollapse: false,
            menusList: [],
            menuItemUrl: [],
            name: 'slide-fade',
            mode: 'out-in'
        }
    },
    computed: {
        activeIndex() {
            return this.$route.meta.otherPath
                ? this.$route.meta.otherPath
                : this.$route.path
        }
    },
    methods: {
        // 初始化
        initData() {
            this.getMenus()
            if (!storage.getAreas()) this.getAreaList()
        },
        // 获取区域列表字典
        async getAreaList() {
            await this.$utils.getAreas().then(res => {
                storage.setAreas(res)
            });
        },
        // 左侧菜单
        getMenus() {
            let id = storage.getId()

            this.$http.user.operatorsMenus(id).then(res => {
                this.menusList = res.data_list
                this.$nextTick(function(){
                    this.menusList.forEach(ele => {
                        if (!ele.children) {
                            this.menuItemUrl.push(ele.menu_url)
                        }
                    });
                })
            }).catch(() => {})
        },
        //折叠导航栏
        collapse() {
            this.isCollapse = !this.isCollapse
        },
        // 退出登录
        logout() {
            this.$confirm('确定退出登录？', '提示',{type: 'warning'}).then(() => {
                sessionStorage.clear()
                this.$router.push({
                    path: '/login'
                })
                this.$message({
                    message: '退出登录成功',
                    type: 'success'
                })
            })
            .catch(action => {})
        },
        // 菜单选择事件
        handleSelect(key, keyPath) {
            //*选择一级关闭二级菜单展开
            for (const index in this.menuItemUrl) {
                if (this.menuItemUrl.hasOwnProperty(index)) {
                    if (key.indexOf(this.menuItemUrl[index]) > -1) {
                        this.$refs.menu.closeMenu(this.$refs.menu.openedMenus[0])
                    }
                }
            }
        }
    },
    mounted() {
        this.initData()
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.container {
    position: absolute;
    top: 0px;
    bottom: 0px;
    width: 100%;

    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all 0.3s ease;
    }
    .slide-fade-leave-active {
        transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */ {
        transform: translateX(10px);
        opacity: 0;
    }

    .topbar-wrap {
        height: 50px;
        line-height: 50px;
        background: #333744;
        padding: 0px;

        .topbar-btn {
            color: #fff;
        }
        /*.topbar-btn:hover {*/
        /*background-color: #4A5064;*/
        /*}*/
        .topbar-logo {
            float: left;
            width: 59px;
            line-height: 26px;
        }
        .topbar-logos {
            float: left;
            width: 120px;
            line-height: 26px;
        }
        .topbar-logo img,
        .topbar-logos img {
            height: 40px;
            margin-top: 5px;
            margin-left: 2px;
        }
        .topbar-title {
            float: left;
            text-align: left;
            width: auto;
            padding-left: 10px;
            border-left: 1px solid #000;
        }
        .topbar-account {
            float: right;
            padding-right: 12px;
        }
        .userinfo-inner {
            cursor: pointer;
            color: #fff;
            padding-left: 10px;
        }
    }
    .main {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        position: absolute;
        top: 50px;
        bottom: 0px;
        overflow: hidden;
    }

    aside {
        background: #333744;
        width: auto;
        &::-webkit-scrollbar {
            display: none;
        }

        &.showSidebar {
            overflow-x: hidden;
            overflow-y: auto;
        }

        .el-menu {
            height: 100%;
            /*写给不支持calc()的浏览器*/
            height: -moz-calc(100% - 80px);
            height: -webkit-calc(100% - 80px);
            height: calc(100% - 80px);
            border-radius: 0px;
            background-color: #333744;
        }

        .el-submenu .el-menu-item {
            min-width: 60px;
        }
        .el-menu {
            width: 200px;
        }
        .el-menu--collapse {
            width: 60px;
        }

        .el-menu .el-menu-item,
        .el-submenu .el-submenu__title {
            height: 46px;
            line-height: 46px;
        }

        .el-menu-item:hover,
        .el-submenu .el-menu-item:hover,
        .el-submenu__title:hover {
            background-color: #7ed2df;
        }

        .el-menu-item  [class*=" el-icon-"], [class^=el-icon-],
        .el-submenu [class*=" el-icon-"], [class^=el-icon-] {
            font-size: 22px !important;
        }
    }

    .menu-toggle {
        // background: #4a5064;
        text-align: center;
        color: white;
        height: 26px;
        line-height: 30px;
        display: inline-block;
        padding-left: 20px;
        cursor: pointer;
    }

    .content-container {
        background: #fff;
        flex: 1;
        overflow: auto;
        padding: 20px;
        padding-bottom: 1px;

        .content-wrapper {
            background-color: #fff;
            box-sizing: border-box;
        }
    }
}

.el-loading-parent--relative {
    .container {
        .main {
            position: unset;
        }
    }
}
</style>



// WEBPACK FOOTER //
// home.vue?8cbe559e